import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";
import { Navigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../router/backendComponents/admin/all_routes";
import { isAuthenticated } from "../../../authentication/backendModule/admin/auth";
import apiRequestCall from "../../../apiHelper/globalHelper";
import { parseValidationErrors } from "../../../apiHelper/validationHelper";
import Export from "../../../formHelper/export";
import Search from "../../../formHelper/search";
import Pagination from "../../../formHelper/pagination";
import Table from "../../../formHelper/list";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Success from "../../../formHelper/success";
import Delete from "../../../formHelper/delete";
import exportApiCall from "../../../apiHelper/export";
import FilterDropdown from "../../../formHelper/filterDropDown";
import Loader from "../../../formHelper/Loader";
import QuillEditor from "../../../formHelper/QuillEditor";
import apiFileRequestCall from "../../../apiHelper/filleHelper";
import CustomPopup from "../../../formHelper/customPopup";
import dayjs from "dayjs";
import { MultiValue, ActionMeta } from "react-select";
import type { RootState } from "../../../core/data/redux/store";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

interface ProductRow {
  id: number;
  part_no: string;
  hsn_no: string;
  price: string | number;
  uom: string;
  igst_rate: string | number;
  discount: string | number;
  quantity: string | number;
  description: string;
  additional_description: string;
  specification: string;
  price_updated_at?: string;
  quantity_updated_at?: string;
  principal_id?: number;
  category_id?: number;
  brand_id?: number;
  image?: string | null;
}

interface OptionKV {
  id: number;
  name: string;
}

interface ImportStatus {
  status: "pending" | "processing" | "completed" | "failed";
  processed_rows: number;
  total_rows: number;
  message?: string;
}

interface CategoryParam {
  id: number;
  parameter_name: string;
  column_name: string;
}

interface UspType {
  id: number;
  usp_type: string;
  category_id: number;
}

interface Permission {
  id: number;
  role_id: number;
  name: string;
  role: {
    permissions: Record<string, Record<string, string>>;
  };
}

const Product = () => {
  const backendRoute = all_routes.backend;

  // listing
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(() => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      return 5;
    }
    return 10;
  });
  const [totalItems, setTotalItems] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [downloading, setDownloading] = useState(false);
  // form
  const [formData, setFormData] = useState<any>({
    part_no: "",
    description: "",
    quantity_date: "",
    price_date: "",
    discount: "",
    igst_rate: "",
    hsn_no: "",
    principal_id: "",
    category_id: "",
    specification: "",
    price: "",
    usp_id: "",
    uom: "",
    quantity: "",
    additional_description: "",
    igst: "",
    hsn: "",
    brand_id: "",
    product_id: "",
  });
  const [formError, setFormError] = useState<{ [k: string]: string }>({});
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);

  // messages
  const [showSuccess, setShowSuccess] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [showUploadMessage, setUploadMessage] = useState("");
  const [showUploadSuccess, setUploadSuccess] = useState(false);

  const [showDeleteMessage, setDeleteMessage] = useState("");
  const [showDeleteSuccess, setDeleteSuccess] = useState(false);
  // delete
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // dropdowns
  const [categoryList, setCategoryList] = useState<OptionKV[]>([]);
  const [principalList, setPrincipalList] = useState<OptionKV[]>([]);
  const [brandList, setBrandList] = useState<OptionKV[]>([]);

  // filters (multi)
  const [branchFilter, setBranchFilter] = useState<number[]>([]);
  const [brandFilter, setBrandFilter] = useState<number[]>([]);
  const [principalFilter, setPrincipalFilter] = useState<number[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<number[]>([]);

  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);

  const [categoryParams, setCategoryParams] = useState<CategoryParam[]>([]);
  const [categoryParamsList, setCategoryParamsList] = useState({});

  const [uspTypes, setUspTypes] = useState<UspType[]>([]);

  const [uspSelected, setUspSelected] = useState<string[]>([]);

  const [principalRefresh, setPrincipalRefresh] = useState(0);
  const [categoryRefresh, setCategoryRefresh] = useState(0);
  const [brandRefresh, setBrandRefresh] = useState(0);

  const [paramFilterData, setParamFilterData] = useState<Record<string, any>>(
    {},
  );

  const [searchText, setSearchText] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState({
    branch: [] as number[],
    brand: [] as number[],
    principal: [] as number[],
    category: [] as number[],
    startDate: "",
    endDate: "",
    searchText: "",
  });

  // uploads
  const [uploading, setUploading] = useState(false);
  const [jobId, setJobId] = useState<number | null>(null);
  const [status, setStatus] = useState<ImportStatus["status"]>("pending");
  const [progress, setProgress] = useState<string>("0/0");

  // request guards
  const [submitting, setSubmitting] = useState(false);
  const [deletingFlag, setDeletingFlag] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const uspOptions =
    uspTypes?.map((u) => ({ label: u.usp_type, value: u.id })) ?? [];

  const toOptions = (arr: OptionKV[]) =>
    arr.map((x) => ({ value: x.id, label: x.name }));

  const inputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    if (name === "price") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }

    setFormError((prev) => {
      const p = { ...prev };
      delete p[name];
      return p;
    });
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      part_no: "",
      hsn_no: "",
      price: "",
      uom: "",
      igst_rate: "",
      quantity: "",
      description: "",
      brand_id: "",
      quantity_date: "",
      additional_description: "",
      specification: "",
      price_date: "",
      discount: "",
      igst: "",
      hsn: "",
      principal_id: "",
      category_id: "",
      product_id: "",
    });
    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }
    setImagePreview(null);
    setImageFile(null);
    setFormError({});
    setSelectedId(null);
    setShowForm(false);
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const fd = new FormData();
      Object.entries(formData).forEach(([key, val]) => {
        if (key === "image_url") return;
        if (val === undefined || val === null) return;
        key = key.replace(/\s+/g, "#");

        if (typeof val === "object") {
          fd.append(key, JSON.stringify(val));
        } else if (key === "usp_id") {
          const uspArray = String(val)
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean);

          fd.append(key, JSON.stringify(uspArray));
        } else {
          fd.append(key, String(val));
        }
      });

      if (selectedId) fd.append("product_id", String(selectedId));
      fd.append("update_status", selectedId ? "1" : "0");
      if (imageFile) {
        fd.append("image", imageFile, imageFile.name);
      }

      const res = await apiFileRequestCall(
        "post",
        backendRoute.addUpdateProduct,
        {
          data: fd,
        },
      );

      if (res?.data?.code === 221) {
        setFormError(parseValidationErrors(res?.data?.errors));
        return;
      }

      if (res?.data?.code === 200) {
        resetForm();
        setShowSuccess(true);
        setShowMessage(res?.data?.message);
        setCategoryParams([]);
        setUspTypes([]);
        await fetchList({ page: currentPage, perPage, search: searchText });
        return;
      }
      setShowMessage(res?.data?.message || "Unexpected response from server");
      setShowSuccess(true);
    } catch (err: any) {
      console.error("Submit failed:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Operation failed. Please try again.";
      setShowMessage(msg);
      setShowSuccess(true);
      setUploading(true);
    } finally {
      setUploading(false);
      setSubmitting(false);
    }
  };

  const updateRecord = (row: ProductRow) => {
    if (submitting || deletingFlag || uploading) return;
    setFormError({});
    const selected = list.find((x) => x.id === row.id);
    if (!selected) return;
    setFormData((prev: any) => ({
      ...prev,
      quantity: selected?.quantity ?? "",
      quantity_date: selected?.quantity_updated_at ?? "",
      price_date: selected?.price_updated_at ?? "",
      igst: selected?.igst_rate ?? "",
      hsn: selected?.hsn_no ?? "",
      product_id: selected?.id ?? "",
      ...selected,
    }));
    setCategoryParams(selected?.category_params);
    setSelectedId(selected.id);
    setImagePreview(selected?.image ?? null);
    setShowForm(true);
    setUspTypes(selected?.category?.usp_type);
    const UspId =
      selected?.usp_id?.split(",").map((v: string) => v.trim()) || [];
    setUspSelected(UspId);
  };

  const deleteRecord = (id: number) => {
    if (submitting || deletingFlag) return;
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    if (deletingFlag) return;
    setDeletingFlag(true);
    try {
      const result = await apiRequestCall("post", backendRoute.deleteProduct, {
        data: { id: deleteId },
      });
      if (result?.data?.code === 200) {
        await fetchList({ page: currentPage, perPage, search: searchText });
        setShowMessage(result?.data?.message);
        setShowSuccess(true);
      }

      if (result?.data?.code === 221) {
        setDeleteMessage(result?.data?.message);
        setDeleteSuccess(true);
      }
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Delete failed. Please try again.");
    } finally {
      setDeleteId(null);
      setShowDeleteModal(false);
      setDeletingFlag(false);
    }
  };

  const listParams = useMemo(
    () => ({
      page: currentPage,
      per_page: perPage,
      start_date: appliedFilters.startDate,
      end_date: appliedFilters.endDate,
      search: appliedFilters.searchText.trim(),
      branch_list: appliedFilters.branch,
      brand_list: brandFilter,
      principal_list: principalFilter,
      category_list: categoryFilter,
    }),
    [currentPage, perPage, appliedFilters],
  );

  const fetchList = async ({
    page = 1,
    perPage: p = 10,
    search = "",
  }: { page?: number; perPage?: number; search?: any } = {}) => {
    setLoading(true);
    if (search) {
      setLoadingSearch(true);
    }
    try {
      const result = await apiRequestCall("post", backendRoute.getProduct, {
        data: {
          page,
          per_page: p,
          start_date: startDate,
          end_date: endDate,
          search: search,
          column: paramFilterData,
          brand_list: Array.isArray(brandFilter)
            ? brandFilter
            : brandFilter != null
              ? brandFilter
              : [],

          branch_list: Array.isArray(branchFilter)
            ? branchFilter
            : branchFilter != null
              ? branchFilter
              : [],

          principal_list: Array.isArray(principalFilter)
            ? principalFilter
            : principalFilter != null
              ? principalFilter
              : [],

          category_list: Array.isArray(categoryFilter)
            ? categoryFilter
            : categoryFilter != null
              ? categoryFilter
              : [],
        },
      });
      const res = result?.data?.data;
      if (res) {
        setList(res.data ?? []);
        setCurrentPage(res.current_page ?? 1);
        setPerPage(res.per_page ?? 10);
        setTotalItems(res.total ?? 0);
      } else {
        setList([]);
        setTotalItems(0);
      }
    } catch (e) {
      console.error("Failed to fetch products:", e);
      setList([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
      setLoadingSearch(false);
    }
  };

  useEffect(() => {
    const isMobileWidth = () =>
      typeof window !== "undefined" && window.innerWidth <= 767.98;

    // set initial value on mount
    if (isMobileWidth()) {
      setPerPage(5);
      setCurrentPage(1);
    } else {
      setPerPage((p) => (p ? p : 10));
    }

    const onResize = () => {
      const mobile = isMobileWidth();
      setPerPage((prev) => {
        const desired = mobile ? 5 : 10;
        if (prev !== desired) {
          setCurrentPage(1);
          return desired;
        }
        return prev;
      });
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ---------- Helpers (download/export)
  const triggerDownload = (url: string, filename: string, revoke = false) => {
    if (!url) return;

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setDownloading(true);
    setTimeout(() => setDownloading(false), 3000);
    setExporting(false);
  };

  // Poll API for local download
  const pollForFile = (filename: string) => {
    let attempts = 0;
    const maxAttempts = 60;

    const interval = setInterval(async () => {
      attempts++;
      try {
        const res = await exportApiCall("get", `/download-export/${filename}`, {
          responseType: "blob",
        });

        if (res) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(true);

          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          triggerDownload(url, filename, true);

          setTimeout(() => setDownloading(false), 3000);
        }
      } catch (err: any) {
        if (err?.response?.status !== 404) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          alert("Export failed while downloading.");
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          alert("Export took too long. Please try again later.");
        }
      }
    }, 5000);
  };

  const exportFile = async () => {
    if (exporting || submitting || deletingFlag || uploading) return;
    try {
      setExporting(true);
      setDownloading(false);

      const result = await apiRequestCall("post", backendRoute.getProduct, {
        data: {
          search: searchText,
          start_date: startDate,
          end_date: endDate,
          branch_list: branchFilter,
          brand_list: brandFilter,
          principal_list: principalFilter,
          category_list: categoryFilter,
          download: true,
          column: paramFilterData,
        },
      });

      const fileUrl = result?.data?.data?.url;

      const filename = result?.data?.data?.file;
      if (!filename) {
        setExporting(false);
        alert("Export request failed. Please try again.");
        return;
      }

      pollForFile(filename);
    } catch (error) {
      console.error("Export request failed:", error);
      setExporting(false);
      setDownloading(false);
      alert("Export failed. Please try again.");
    }
  };

  const getBrandList = async () => {
    const r = await apiRequestCall("post", backendRoute.getBrandDD, {
      data: {
        principal_id: principalFilter ?? null,
        category_id: categoryFilter ?? null,
        brand_id: brandFilter ?? null,
      },
    });

    const raw = r?.data?.data;
    if (raw && typeof raw === "object") {
      setBrandList(
        Object.entries(raw).map(([id, name]) => ({
          id: +id,
          name: String(name),
        })),
      );
    }
  };
  const getCategoryList = async () => {
    const r = await apiRequestCall("post", backendRoute.getCategoryDD, {
      data: {
        principal_id: principalFilter ?? null,
        category_id: categoryFilter ?? null,
        brand_id: brandFilter ?? null,
      },
    });
    const raw = r?.data?.data;
    if (raw && typeof raw === "object") {
      setCategoryList(
        Object.entries(raw).map(([id, name]) => ({
          id: +id,
          name: String(name),
        })),
      );
    }
  };
  const getPrincipalList = async () => {
    const r = await apiRequestCall("post", backendRoute.getPrincipalDD, {
      data: {
        principal_id: principalFilter ?? null,
        category_id: categoryFilter ?? null,
        brand_id: brandFilter ?? null,
      },
    });
    const raw = r?.data?.data;
    if (raw && typeof raw === "object") {
      setPrincipalList(
        Object.entries(raw).map(([id, name]) => ({
          id: +id,
          name: String(name),
        })),
      );
    }
  };

  useEffect(() => {
    const fetchParams = async () => {
      try {
        const res = await apiRequestCall(
          "post",
          backendRoute.getCategoryParameterDD,
          { data: { category_id: categoryFilter } },
        );

        setCategoryParamsList(res?.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchParams();
  }, [categoryFilter]);

  useEffect(() => {
    fetchList({ page: currentPage, perPage, search: searchText });
  }, [searchText, listParams, startDate, endDate, paramFilterData]);

  useEffect(() => {
    setAppliedFilters((p) => ({
      ...p,
      searchText,
      principal: principalFilter,
      category: categoryFilter,
      brand: brandFilter,
      branch: branchFilter,
      startDate,
      endDate,
    }));
    setCurrentPage(1);
  }, [
    principalFilter,
    categoryFilter,
    brandFilter,
    branchFilter,
    searchText,
    startDate,
    endDate,
    paramFilterData,
  ]);

  // load dropdowns once
  useEffect(() => {
    getBrandList();
    getCategoryList();
    getPrincipalList();
  }, []);

  const fmt = (isoOrTs?: string | number | null) => {
    if (!isoOrTs) return "";
    const d = new Date(isoOrTs);
    if (Number.isNaN(d.getTime())) return String(isoOrTs);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const permission = useSelector(
    (state: RootState) => state.rolesPermissions?.data,
  ) as Permission | null;

  const permissionMap = useMemo(() => {
    return permission?.role?.permissions ?? {};
  }, [permission]);

  const columns = [
    { key: "part_no", label: "Part No." },
    { key: "description", label: "Description" },
    {
      key: "quantity",
      label: "Qty",
      render: (item: any) => {
        const qty = item.quantity ?? "";
        const date = fmt(item.quantity_updated_at);

        return (
          <div>
            <div>{qty}</div>
            {date && <div>{date}</div>}
          </div>
        );
      },
    },

    {
      key: "price",
      label: "Price",
      render: (item: any) => {
        const price = item.price ?? "";
        const date = fmt(item.price_updated_at);

        const content = (
          <div>
            <div>{price}</div>
            {date && <div>{date}</div>}
          </div>
        );

        if (
          item?.supplier &&
          (permissionMap?.supplier?.edit_supplier ||
            permissionMap?.supplier?.view_supplier)
        ) {
          return (
            <Link
              title="View Supplier"
              state={{ partId: item?.id, partInfo: item?.part_no }}
              to={"/supplier"}
              style={{ color: "blue", textDecoration: "none" }}
            >
              {content}
            </Link>
          );
        }

        return content;
      },
    },

    {
      key: "discount",
      label: "Disc %",
      render: (item: any) => {
        const discount = Number(item.discount ?? 0);

        return discount.toFixed(2);
      },
    },
    { key: "igst_rate", label: "IGST" },
    { key: "hsn_no", label: "HSN" },
    { key: "principal.type", label: "Principal" },
    { key: "category.name", label: "Category" },
    {
      key: "image",
      label: "Image",
      render: (item: any) => {
        const defaultImage = "/assets/img/products/product1.jpg";
        const imageUrl = item.image ? item.image : defaultImage;

        return (
          <img
            src={imageUrl}
            alt={item.part_no || "Product"}
            style={{
              width: 50,
              height: 50,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #ddd",
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).src = defaultImage;
            }}
          />
        );
      },
    },
    // { key: "created_at", label: "Date" },

    ...(permissionMap?.product?.edit_product ||
    permissionMap?.product?.delete_product
      ? [
          {
            key: "action",
            label: "Action",
            render: (row: any) => (
              <div className="hstack gap-2 fs-15">
                {permissionMap?.product?.edit_product && (
                  <button
                    className="btn btn-icon btn-sm btn-soft-info"
                    onClick={() => updateRecord(row)}
                    disabled={submitting || deletingFlag || uploading}
                    title="Edit"
                    aria-label={`Edit product ${row.part_no}`}
                  >
                    <i className="feather-edit" />
                  </button>
                )}

                {permissionMap?.product?.delete_product && (
                  <button
                    className="btn btn-icon btn-sm btn-soft-danger"
                    onClick={() => deleteRecord(row.id)}
                    disabled={submitting || deletingFlag || uploading}
                    title="Delete"
                    aria-label={`Delete product ${row.part_no}`}
                  >
                    <i className="feather-trash" />
                  </button>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  const handleFileUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    const file = e.currentTarget.files?.[0];
    if (!file || uploading) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const fd = new FormData();
    fd.append("file", file);
    setUploadSuccess(false);
    setUploadMessage("");
    setUploading(true);

    try {
      const res = await apiFileRequestCall(
        "post",
        backendRoute.uploadProductFile,
        { data: fd },
      );
      const code = res?.data?.code;
      const msg = res?.data?.message ?? "";

      if (code === 200) {
        const job = res?.data?.data?.job_id ?? null;
        setJobId(job);
        setShowSuccess(true);
        setShowMessage("File uploaded. Processing in background…");
      } else {
        setUploadSuccess(true);
        setUploadMessage(msg || "Upload failed");
        setUploading(false);
      }
    } catch (err) {
      console.error("File upload error:", err);
      setUploadSuccess(false);
      setUploadMessage("Upload failed due to network/server error");
      setUploading(false);
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  // import status polling
  useEffect(() => {
    if (!jobId) return;
    let interval: ReturnType<typeof setInterval>;

    const fetchStatus = async () => {
      try {
        const res = await apiRequestCall("post", backendRoute.importStatus, {
          data: { id: jobId },
        });
        const data: ImportStatus | undefined = res?.data?.data;
        if (!data) return;

        setStatus(data.status);
        const processed = Number(data.processed_rows ?? 0);
        const total = Number(data.total_rows ?? 0);
        setProgress(`${processed}/${total}`);

        if (data.status === "completed" || data.status === "failed") {
          clearInterval(interval);
          setShowSuccess(true);
          setUploading(false);
          setShowMessage(
            data.status === "completed"
              ? "Import completed successfully."
              : (data.message ?? "Import failed."),
          );
          await fetchList({ page: currentPage, perPage, search: searchText });
        }
      } catch (error) {
        console.error("Error fetching import status:", error);
        clearInterval(interval);
      }
    };

    interval = setInterval(fetchStatus, 5000);
    fetchStatus();

    return () => clearInterval(interval);
  }, [jobId]);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] ?? null;
    if (!f) return;

    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }

    const url = URL.createObjectURL(f);
    setImageFile(f);
    setImagePreview(url);

    setFormError((prev) => {
      const copy = { ...prev };
      delete copy.image;
      return copy;
    });
  };

  const getParamsList = useCallback(
    async (categoryId?: number | null) => {
      const id =
        typeof categoryId !== "undefined" ? categoryId : formData?.category_id;
      if (!id) {
        setCategoryParams([]);
        setUspTypes([]);
        return;
      }

      try {
        const res = await apiRequestCall(
          "post",
          backendRoute.getCategoryParams,
          { data: { category_id: id } },
        );
        if (res?.data?.data) setCategoryParams(res.data?.data?.["parameter"]);
        if (res?.data?.data) setUspTypes(res.data?.data?.["usp_type"]);
      } catch (err) {
        console.error(err);
      }
    },
    [formData],
  );

  const onPrincipalChange = (v: number[]) => {
    setPrincipalFilter(v);

    setCategoryRefresh((k) => k + 1);
    setBrandRefresh((k) => k + 1);
  };

  const onCategoryChange = (v: number[]) => {
    setCategoryFilter(v);
    setPrincipalRefresh((k) => k + 1);
    setBrandRefresh((k) => k + 1);
  };

  const onBrandChange = (v: number[]) => {
    setBrandFilter(v);

    setPrincipalRefresh((k) => k + 1);
    setCategoryRefresh((k) => k + 1);
  };

  const searchTextData = (text: string) => {
    setSearchText(text);
  };

  if (!isAuthenticated()) return <Navigate to="/login" replace />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row page-header">
          <div className="col-12">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <h4 className="page-title">
                  Products <span className="count-title">{totalItems}</span>
                </h4>

                {jobId && (status === "pending" || status === "processing") && (
                  <div className="small text-muted mt-1">
                    Import: {status} — {progress}
                  </div>
                )}
              </div>
              <div className="col-12 col-md-4 search-col">
                <div className="card-control position-relative">
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <Search
                      placeholder="Enter Text ..."
                      value={query}
                      onChange={setQuery}
                      searchText={searchTextData}
                      loading={loadingSearch}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                <div className="d-flex justify-content-end gap-2">
                  {permissionMap?.product?.export_product && (
                    <Export
                      options={[
                        {
                          label: downloading
                            ? "Downloading..."
                            : exporting
                              ? "Generating..."
                              : "Export",
                          iconClass: downloading
                            ? "ti ti-download"
                            : exporting
                              ? "ti ti-loader"
                              : "ti ti-file-type-xls",
                          colorClass:
                            exporting || downloading
                              ? "text-muted"
                              : "text-primary",
                          onClick:
                            exporting ||
                            downloading ||
                            submitting ||
                            deletingFlag ||
                            uploading
                              ? undefined
                              : exportFile,
                        },
                      ]}
                    />
                  )}

                  {permissionMap?.product?.add_product && (
                    <button
                      className="btn btn-soft-success d-flex align-items-center"
                      onClick={() => {
                        resetForm();
                        setShowForm(true);
                      }}
                      disabled={submitting}
                      aria-label="Add new"
                    >
                      <i className="ti ti-square-rounded-plus" />
                      <span className="d-none d-md-inline ms-1">New</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Top card: search / upload / date / filter */}
        <div className="card mb-2">
          <div className="card-body">
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-3 date-col">
                <div className="card-control position-relative">
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar" />
                    </span>
                    <DateRangePicker
                      initialSettings={{
                        autoUpdateInput: false,
                        locale: { cancelLabel: "Clear" },
                      }}
                      onCallback={(start, end) => {
                        setStartDate(start.format("YYYY-MM-DD"));
                        setEndDate(end.format("YYYY-MM-DD"));
                      }}
                      onCancel={() => {
                        setStartDate("");
                        setEndDate("");
                      }}
                    >
                      <input
                        type="text"
                        className="form-control bookingrange"
                        placeholder="Select Date Range Filter"
                        value={
                          startDate && endDate
                            ? `${dayjs(startDate).format(
                                "DD-MM-YYYY",
                              )} - ${dayjs(endDate).format("DD-MM-YYYY")}`
                            : ""
                        }
                        readOnly
                        style={{ cursor: "pointer" }}
                        aria-label="Select date range"
                      />
                    </DateRangePicker>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Principal"
                  endpoint="/getPrincipalDD"
                  selected={principalFilter}
                  refreshKey={principalRefresh}
                  onChange={(v) => {
                    onPrincipalChange(v as number[]);
                  }}
                  payload={{
                    category_id: categoryFilter ?? null,
                    brand_id: brandFilter ?? null,
                  }}
                />
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Category"
                  endpoint="/getCategoryDD"
                  selected={categoryFilter}
                  refreshKey={categoryRefresh}
                  onChange={(v) => {
                    onCategoryChange(v as number[]);
                    setParamFilterData({});
                  }}
                  payload={{
                    principal_id: principalFilter ?? null,
                    brand_id: brandFilter ?? null,
                  }}
                />
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Brand"
                  endpoint="/getBrandDD"
                  selected={brandFilter}
                  refreshKey={brandRefresh}
                  onChange={(v) => {
                    onBrandChange(v as number[]);
                  }}
                  payload={{
                    principal_id: principalFilter ?? null,
                    category_id: categoryFilter ?? null,
                  }}
                />
              </div>

              {/* <div className="col-12 col-md-3">
                <FilterDropdown
                  label="Branch"
                  endpoint="/getBranchDD"
                  selected={branchFilter}
                  onChange={(v) => setBranchFilter(v as number[])}
                />
              </div> */}

              {(permissionMap?.product?.import_product_quantity ||
                permissionMap?.product?.import_product_price) && (
                <div className="col-12 col-sm-3">
                  {uploading ? (
                    <div className="d-flex align-items-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      />
                      <span className="ms-1">Importing...</span>
                    </div>
                  ) : (
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".xls,.xlsx"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      disabled={submitting || deletingFlag}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {categoryParamsList && Object.keys(categoryParamsList).length > 0 && (
          <div className="card mb-1 mt-1">
            <div className="card-body">
              <div className="row g-2 align-items-center">
                {Object.entries(categoryParamsList).map(([field, values]) => (
                  <div className="col-md-2" key={field}>
                    <div className="mb-1">
                      <label className="col-form-label text-warning">
                        {field.replaceAll("_", " ")}
                      </label>

                      <Select
                        classNamePrefix="react-select"
                        options={(values as string[]).map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        value={
                          (values as string[])
                            .map((v) => ({ label: v, value: v }))
                            .find((o) => o.value === paramFilterData[field]) ||
                          null
                        }
                        onChange={(opt) =>
                          setParamFilterData((prev: any) => ({
                            ...prev,
                            [field]: opt?.value ?? null,
                          }))
                        }
                        isClearable
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Table card */}
        <div className="card">
          <div className="card-body">
            {loading ? <Loader /> : <Table data={list} columns={columns} />}
          </div>

          <Pagination
            currentPage={currentPage}
            perPage={perPage}
            totalItems={totalItems}
            onPageChange={(p) => {
              setCurrentPage(p);
              fetchList({ page: p, perPage, search: searchText });
            }}
            onPerPageChange={(n) => {
              setPerPage(n);
              setCurrentPage(1);
              fetchList({ page: 1, perPage: n, search: searchText });
            }}
            perPageOptions={[
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 25, label: "25" },
            ]}
          />
        </div>

        {/* Offcanvas Form */}
        <div
          className={`offcanvas offcanvas-end offcanvas-large ${
            showForm ? "show" : ""
          }`}
          style={{
            visibility: showForm ? "visible" : "hidden",
          }}
          tabIndex={-1}
          role="dialog"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">
              {selectedId ? "Update Product" : "Add Product"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                if (!submitting) {
                  setShowForm(false);
                  setCategoryParams([]);
                  setUspTypes([]);
                }
              }}
              disabled={submitting || uploading}
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!submitting) handleSubmit();
              }}
            >
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">Upload Image</label>
                    <input
                      name="image"
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={handleImageChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.image && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.image}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3 mt-2">
                    <img
                      src={
                        imagePreview
                          ? imagePreview
                          : "/assets/img/products/product1.jpg"
                      }
                      alt="preview"
                      style={{
                        width: 80,
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* rest of form fields (disabled when submitting) */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Part No. <span className="text-danger">*</span>
                    </label>
                    <input
                      name="part_no"
                      type="text"
                      className="form-control"
                      value={formData.part_no}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.part_no && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.part_no}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      HSN No. <span className="text-danger">*</span>
                    </label>
                    <input
                      name="hsn_no"
                      type="text"
                      className="form-control"
                      value={formData.hsn_no}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.hsn_no && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.hsn_no}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Price / UOM */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Price <span className="text-danger">*</span>
                    </label>
                    <input
                      name="price"
                      type="text"
                      className="form-control"
                      value={formData.price}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.price && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.price}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      UOM <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="uom"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={[
                        // Weight
                        { value: "kg", label: "Kilograms (kg)" },
                        { value: "g", label: "Grams (g)" },
                        { value: "mg", label: "Milligrams (mg)" },
                        { value: "lb", label: "Pounds (lb)" },
                        { value: "oz", label: "Ounces (oz)" },

                        // Volume
                        { value: "l", label: "Liters (L)" },
                        { value: "ml", label: "Milliliters (mL)" },
                        { value: "gal", label: "Gallons (gal)" },
                        { value: "pt", label: "Pints (pt)" },

                        // Length
                        { value: "m", label: "Meters (m)" },
                        { value: "cm", label: "Centimeters (cm)" },
                        { value: "mm", label: "Millimeters (mm)" },
                        { value: "km", label: "Kilometers (km)" },
                        { value: "in", label: "Inches (in)" },
                        { value: "ft", label: "Feet (ft)" },
                        { value: "yd", label: "Yards (yd)" },

                        // Count/Units
                        { value: "pcs", label: "Pieces" },
                        { value: "dozen", label: "Dozen" },
                        { value: "pack", label: "Pack" },
                        { value: "box", label: "Box" },
                        { value: "set", label: "Set" },
                        { value: "pair", label: "Pair" },
                        { value: "roll", label: "Roll" },
                        { value: "bottle", label: "Bottle" },
                        { value: "bag", label: "Bag" },
                        { value: "carton", label: "Carton" },

                        // Area
                        { value: "sqm", label: "Square Meters (m²)" },
                        { value: "sqft", label: "Square Feet (ft²)" },

                        // Time
                        { value: "hr", label: "Hours (hr)" },
                        { value: "min", label: "Minutes (min)" },
                        { value: "sec", label: "Seconds (s)" },
                      ]}
                      value={
                        formData.uom
                          ? {
                              value: formData.uom,
                              label: [
                                { value: "kg", label: "Kilograms (kg)" },
                                { value: "g", label: "Grams (g)" },
                                { value: "mg", label: "Milligrams (mg)" },
                                { value: "lb", label: "Pounds (lb)" },
                                { value: "oz", label: "Ounces (oz)" },
                                { value: "l", label: "Liters (L)" },
                                { value: "ml", label: "Milliliters (mL)" },
                                { value: "gal", label: "Gallons (gal)" },
                                { value: "pt", label: "Pints (pt)" },
                                { value: "m", label: "Meters (m)" },
                                { value: "cm", label: "Centimeters (cm)" },
                                { value: "mm", label: "Millimeters (mm)" },
                                { value: "km", label: "Kilometers (km)" },
                                { value: "in", label: "Inches (in)" },
                                { value: "ft", label: "Feet (ft)" },
                                { value: "yd", label: "Yards (yd)" },
                                { value: "pcs", label: "Pieces" },
                                { value: "dozen", label: "Dozen" },
                                { value: "pack", label: "Pack" },
                                { value: "box", label: "Box" },
                                { value: "set", label: "Set" },
                                { value: "pair", label: "Pair" },
                                { value: "roll", label: "Roll" },
                                { value: "bottle", label: "Bottle" },
                                { value: "bag", label: "Bag" },
                                { value: "carton", label: "Carton" },
                                { value: "sqm", label: "Square Meters (m²)" },
                                { value: "sqft", label: "Square Feet (ft²)" },
                                { value: "hr", label: "Hours (hr)" },
                                { value: "min", label: "Minutes (min)" },
                                { value: "sec", label: "Seconds (s)" },
                              ].find((o) => o.value === formData.uom)?.label,
                            }
                          : null
                      }
                      onChange={(opt) => {
                        setFormError((prev) => {
                          const q = { ...prev };
                          delete q.uom;
                          return q;
                        });
                        setFormData((prev: any) => ({
                          ...prev,
                          uom: opt?.value || null,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting || uploading || deletingFlag}
                    />
                    {formError.uom && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.uom}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* IGST / Discount */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      IGST <span className="text-danger">*</span>
                    </label>
                    <input
                      name="igst_rate"
                      type="text"
                      className="form-control"
                      value={formData.igst_rate}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.igst_rate && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.igst_rate}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Discount <span className="text-danger">*</span>
                    </label>
                    <input
                      name="discount"
                      type="text"
                      className="form-control"
                      value={formData.discount}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.discount && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.discount}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Selects */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Select Category <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="category_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={toOptions(categoryList)}
                      value={
                        toOptions(categoryList).find(
                          (o) => o.value === formData.category_id,
                        ) || null
                      }
                      onChange={(opt) => {
                        const selectedId = opt?.value ?? null;

                        // clear category + dynamic field errors
                        setFormError((prev: Record<string, any>) => {
                          const q = { ...prev };
                          delete q.category_id;
                          delete q.usp_id; // clear USP errors too
                          categoryParams?.forEach((p: any) => {
                            if (p?.column_name) delete q[p.column_name];
                          });
                          return q;
                        });

                        // clear only dynamic params + usp_id from formData
                        setFormData((prev: Record<string, any>) => {
                          const copy = { ...prev };
                          categoryParams?.forEach((p: any) => {
                            if (p?.column_name) delete copy[p.column_name];
                          });
                          return {
                            ...copy,
                            category_id: selectedId,
                            usp_id: null, // reset USP dropdown
                          };
                        });

                        // reset lists so UI clears instantly
                        setCategoryParams([]);
                        setUspTypes([]);

                        // load new params for selected category
                        getParamsList(selectedId);
                      }}
                      isClearable
                      isDisabled={submitting || uploading || deletingFlag}
                    />

                    {formError.category_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.category_id}
                      </div>
                    )}
                  </div>
                </div>

                {uspTypes?.length > 0 && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Select USP <span className="text-danger">*</span>
                      </label>

                      <Select
                        isMulti
                        className="tagging"
                        classNamePrefix="react-select"
                        options={uspTypes.map((u: any) => ({
                          value: String(u.id),
                          label: u.usp_type,
                        }))}
                        value={uspTypes
                          .filter((u: any) =>
                            uspSelected.includes(String(u.id)),
                          )
                          .map((u: any) => ({
                            value: String(u.id),
                            label: u.usp_type,
                          }))}
                        onChange={(
                          selected: MultiValue<{
                            value: string;
                            label: string;
                          }>,
                          _actionMeta: ActionMeta<{
                            value: string;
                            label: string;
                          }>,
                        ) => {
                          const selectedIds = selected.map((opt) => opt.value);

                          setUspSelected(selectedIds);

                          setFormError((prev: any) => {
                            const next = { ...prev };
                            delete next.usp_id;
                            return next;
                          });

                          setFormData((prev: any) => ({
                            ...prev,
                            usp_id: selectedIds,
                          }));
                        }}
                        isClearable
                        isDisabled={submitting || uploading || deletingFlag}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: "green",
                            boxShadow: "none",
                            "&:hover": { borderColor: "green" },
                          }),
                        }}
                      />
                      {formError.usp_id && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.usp_id}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {categoryParams.length > 0 &&
                  categoryParams.map((param: any) => {
                    if (param.column_name === "str_usp_phase") return null;

                    return (
                      <div className="col-md-6" key={param.id}>
                        <div className="mb-3">
                          <label className="col-form-label">
                            {param.column_name}{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <input
                            style={{ borderColor: "green" }}
                            type="text"
                            name={param.column_name}
                            className={`form-control ${
                              formError[param.column_name] ? "is-invalid" : ""
                            }`}
                            required
                            value={formData[param.column_name] || ""}
                            onChange={(e) => {
                              let { name, value } = e.target;

                              const numericFields = [
                                "str_pore_size",
                                "str_columnlenght_mm",
                                "str_columnid_mm",
                                "str_film_thikness_mm",
                              ];

                              // Allow only numbers and decimal
                              if (numericFields.includes(name)) {
                                value = value.replace(/[^0-9.]/g, "");

                                // Prevent multiple decimal points
                                const parts = value.split(".");
                                if (parts.length > 2) {
                                  value =
                                    parts[0] + "." + parts.slice(1).join("");
                                }
                              }

                              // Remove error dynamically
                              setFormError((prev: any) => {
                                const copy = { ...prev };
                                delete copy[name];
                                return copy;
                              });

                              setFormData((prev: any) => ({
                                ...prev,
                                [name]: value,
                              }));
                            }}
                            onBlur={(e) => {
                              let { name, value } = e.target;

                              // Auto convert to 0.00 format
                              if (
                                [
                                  "str_columnid_mm",
                                  "str_film_thikness_mm",
                                ].includes(name) &&
                                value !== ""
                              ) {
                                value = parseFloat(value || "0").toFixed(2);

                                setFormData((prev: any) => ({
                                  ...prev,
                                  [name]: value,
                                }));
                              }
                            }}
                            disabled={submitting || uploading || deletingFlag}
                          />

                          {formError[param.column_name] && (
                            <div className="invalid-feedback d-block text-danger">
                              {formError[param.column_name]}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Select Brand <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="brand_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={toOptions(brandList)}
                      value={
                        toOptions(brandList).find(
                          (o) => o.value === formData.brand_id,
                        ) || null
                      }
                      onChange={(opt) => {
                        setFormError((p) => {
                          const q = { ...p };
                          delete q.brand_id;
                          return q;
                        });
                        setFormData((prev: any) => ({
                          ...prev,
                          brand_id: opt?.value || null,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting || uploading || deletingFlag}
                    />
                    {formError.brand_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.brand_id}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Principal / Quantity */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Select Principal <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="principal_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={toOptions(principalList)}
                      value={
                        toOptions(principalList).find(
                          (o) => o.value === formData.principal_id,
                        ) || null
                      }
                      onChange={(opt) => {
                        setFormError((p) => {
                          const q = { ...p };
                          delete q.principal_id;
                          return q;
                        });
                        setFormData((prev: any) => ({
                          ...prev,
                          principal_id: opt?.value || null,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting || uploading || deletingFlag}
                    />
                    {formError.principal_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.principal_id}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      name="quantity"
                      type="text"
                      className="form-control"
                      value={formData.quantity}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.quantity && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.quantity}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Descriptions */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      name="description"
                      className="form-control"
                      style={{ height: 120 }}
                      value={formData.description}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.description && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.description}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Additional Description{" "}
                    </label>
                    <textarea
                      name="additional_description"
                      className="form-control"
                      style={{ height: 120 }}
                      value={formData.additional_description}
                      onChange={inputChange}
                      disabled={submitting || uploading || deletingFlag}
                    />
                    {formError.additional_description && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.additional_description}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="mb-3">
                  <label className="col-form-label">Specification</label>
                  <QuillEditor
                    theme="snow"
                    value={formData.specification}
                    onChange={(html: string) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        specification: html,
                      }));
                      setFormError((p) => {
                        const q = { ...p };
                        delete q.specification;
                        return q;
                      });
                    }}
                    height={150}
                  />
                </div>
                {formError.specification && (
                  <div className="invalid-feedback d-block text-danger">
                    {formError.specification}
                  </div>
                )}
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-soft-primary me-2"
                  onClick={() => {
                    setShowForm(false);
                    setCategoryParams([]);
                    setUspTypes([]);
                  }}
                  disabled={submitting || uploading || deletingFlag}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-soft-success"
                  disabled={submitting || uploading || deletingFlag}
                >
                  {submitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      {selectedId ? "Updating..." : "Creating..."}
                    </>
                  ) : selectedId ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

        <Success
          id="formatSuccessModal"
          title="Product"
          message={showMessage}
          show={showSuccess}
          onClose={() => setShowSuccess(false)}
        />
        <Delete
          show={showDeleteModal}
          title="Delete Product?"
          message="Are you sure to delete ?"
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
        />

        <CustomPopup
          id="formatSuccessModal"
          title="Error Upload"
          message={showUploadMessage}
          show={showUploadSuccess}
          onClose={() => setUploadSuccess(false)}
          type="error"
        />

        <CustomPopup
          show={showDeleteSuccess}
          title="Product Already Linked"
          message={showDeleteMessage}
          onClose={() => setDeleteSuccess(false)}
          type="error"
        />
      </div>
    </div>
  );
};

export default Product;
